import ClassManager from "./classManager";

const UIUtil = {
    ClassManager: new ClassManager(),
}

export default UIUtil;